export const DEFAULT_CENTER = {
  lat: 35.6585805,
  lng: 139.7454329,
};
export const DEFAULT_ZOOM = 15;
export const DEFAULT_DISTANCE = 5;
